import type { ComputeInsightKind } from './computeTypes';

export const SPO_COMPUTE_ROOT = '/spocompute';

export const COMPUTE_TABS: ReadonlyArray<{ kind: ComputeInsightKind; label: string }> = [
    { kind: 'cores-per-kdau', label: 'Cores/kDAU: Total & USR' },
    { kind: 'cores-per-kdau-bot', label: 'Cores/kDAU: BOT' },
    { kind: 'active-users', label: 'DAU & MAU' },
];

export function computePath(kind: ComputeInsightKind, search = ''): string {
    const query = search.startsWith('?') ? search.slice(1) : search;
    return `${SPO_COMPUTE_ROOT}/${kind}${query ? `?${query}` : ''}`;
}
